import { Directive, ElementRef, Input,Output, OnChanges, SimpleChanges, EventEmitter } from '@angular/core';


/**
 * Directiva para mostrar el logo si está disponible en los parámetros del back-end.
 *
 * @export
 * @class LogoLoader
 */
@Directive({
  selector: '[logo-loader]'
})
export class LogoLoader implements OnChanges{

  /**
   * Contiene el path del logo a cargar.
   *
   * @type {string}
   * @memberof LogoLoader
   */
  @Input('logo-loader') logoLoader: string = '';

  @Input('default-logo') defLogo: string = '';

  @Output() logoChanged: EventEmitter<any> = new EventEmitter<any>();

  timeoutInterval: any = null; 
  
  /**
   * Constructor de la directiva.
   *
   * @param {ElementRef}  element
   */
  public constructor(
    private element: ElementRef
  ) {
    //this.element.nativeElement.src = this.minImg();
     
      this.element.nativeElement.onload = (evt)=>{
        this.logoChanged.next(this.element.nativeElement.src);
      }
  
      this.element.nativeElement.onerror = (evt)=>{
        let src = this.defLogo;
        this.element.nativeElement.src = src;
        this.logoChanged.next(this.element.nativeElement.src);
      }
   }

   ngAfterViewInit(){
      this.timeoutInterval = setTimeout(()=>{
        this.element.nativeElement.src = this.defLogo;
      },300);
      this.changeLogo();
   }

   ngOnChanges(changes: SimpleChanges){
     if(changes.logoLoader) this.changeLogo();
   }


   /**
    * Cambia el logo.
    *
    * @memberof LogoLoader
    */
   changeLogo(): void{
      if(this.logoLoader){
        clearTimeout(this.timeoutInterval);
        this.element.nativeElement.src = this.logoLoader;
        
      } 
   }

}



// WEBPACK FOOTER //
// ./src/modules/utils/logo-loader/logo-loader.directive.ts